import { connect } from 'react-redux';
import ResourceRow from './ResourceRow';
import { userStatusLoading } from '../../../../../store/selectors/user.selector';
import { updateUserStatus, sortResourceRequest, updateUserFlag } from '../../../../../store/actions/user.actions';

const mapDispatchToProps = { updateUserStatus, sortResourceRequest, updateFlag: updateUserFlag };

const mapStateToProps = (state) => { 
    const statusLoading = userStatusLoading(state);

    return { statusLoading };
 };

export default connect(mapStateToProps, mapDispatchToProps)(ResourceRow);